import { CircularProgress, List } from "@mui/material";

import { DEFAULT_PAGINATION_LIMIT } from "../../../../../globalConstants";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import Pagination from "../../../cm/Dashboard/FullPages/CaseList/CaseListList/components/Pagination";
import { useActionItemPermissions } from "../hooks/useActionItemPermissions";

import ActionItemRow from "./ActionItemRow";
import ActionItemsTableHeader from "./ActionItemsTableHeader";

const ACTION_ITEMS_QUERY_OPTIONS = { debounceMs: 0, replaceNavigation: true };

export default function ActionItemsTable({
  actionItems,
  loading,
  resultCount,
  ordering,
  onOrderingChange,
  onEdit,
  onDelete,
  onView,
  onNavigateToClient,
  caseId,
}) {
  const { canViewFollowUps } = useActionItemPermissions();
  const { filters, updateFilter } = useQueryParams(ACTION_ITEMS_QUERY_OPTIONS);

  if (loading) {
    return (
      <div className="my-24 flex justify-center">
        <CircularProgress color="secondary" />
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col">
      <ActionItemsTableHeader
        ordering={ordering}
        onOrderingChange={onOrderingChange}
        showClientColumn={!caseId}
        showTypeColumn={canViewFollowUps}
      />

      <div className="relative min-h-0 flex-1 overflow-y-auto">
        <List disablePadding>
          {actionItems.length === 0 ? (
            <div className="my-12 text-center text-gray-500">No action items found</div>
          ) : (
            actionItems.map((actionItem) => (
              <ActionItemRow
                key={actionItem.pk}
                actionItem={actionItem}
                onEdit={onEdit}
                onDelete={onDelete}
                onView={onView}
                caseId={caseId}
                showClientColumn={!caseId}
                showTypeColumn={canViewFollowUps}
                onNavigateToClient={onNavigateToClient}
              />
            ))
          )}
        </List>
        <div className="flex justify-center border-t bg-white py-3">
          <Pagination
            filters={filters}
            updateFilter={updateFilter}
            totalCount={resultCount.total}
            limit={DEFAULT_PAGINATION_LIMIT}
          />
        </div>
      </div>
    </div>
  );
}
